export function slotKey(scope: string, name: string): string {
  return name ? `${scope}/${name}` : scope
}

export const SLOT_LABELS: Readonly<Record<string, string>> = {
  guardrails: 'Запреты',
  persona: 'Персона Милы',
  'system/daily-reading': 'Задача: карта дня',
  'system/chat': 'Задача: диалог',
  'system/daily-card-reading': 'Задача: карта дня эксперта',
}
